<template>
    <div class="phhonor ph-news-detail">
        <el-backtop ></el-backtop>
        <hpheader></hpheader>
        <div class="ph-news-detail-container">
            <position-bar :positionNav="positionNav">
            </position-bar>
            <div class="line"></div>
            <div class="created-time">
                {{ $utils.formatDate(data.createtime) }}
            </div>
            <h3 class="title">{{ data.en_title }}</h3>
            <div class="line"></div>

            <div class="info_con">
                <div class="detail-page-bd">
                    <div class="html-text-component parbase">
                        <span class="one_line"></span>
                        <div id="news_contain" v-html="data.en_content">
                        </div>
                    </div>
                </div>
            </div>

            <div class="line"></div>
            <div class="pagination">
                <div class="prev" @click="toPrev" >
                    <span v-if="data.prev"><i class="el-icon-back"></i>上一页</span>
                </div>
                <div class="next" @click="toNext" v-if="data.next">
                    <span v-if="data.next">下一页 <i class="el-icon-right"></i></span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from "../../storage/storage";
    import positionBar from '../../components/ph-position-bar.vue'

    export default {
        name: "ph-news-detail",
        components:{
            hpfooter,
            hpheader,
            positionBar,
        },
        data(){
            return {
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'News',
                        path:'/pc-news',
                    },
                    {
                        title:'',
                        paht:''
                    }
                ],
                id:0,
                data:{}
            }
        },
        watch:{
            '$route': 'getParams'
        },
        created(){
            this.id = this.$route.query.id

            if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'./pc-news-detail',query:{id:this.id}})
                return;
            }

            if(!this.id){
                this.$router.push({path: '/ph-news'})
                return
            }
        },
        mounted() {
            this.ress()
            this.detail()
        },
        methods:{
            getParams(){
                this.id = this.$route.query.id
                this.detail()
            },
            toPrev(){
                this.$router.push({path: '/ph-news-detail',query:{
                        id:this.data.prev.id
                    }})
            },
            toNext(){
                this.$router.push({path: '/ph-news-detail',query:{
                        id:this.data.next.id
                    }})
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },
            detail(){
                this.$api.get_news_center_detail({id:this.id}).then(res => {
                    if(res.code <= 0){
                        this.$router.push({path: '/ph-news'})
                        return
                    }
                    this.data = res.data
                    this.positionNav[2].title = res.data.en_title
                })
            },
        }
    }
</script>
<style>
    .ph-news-detail {
        background: #FFF;
        padding-top: 1rem;
    }
    .ph-news-detail .ph-news-detail-container {
        font-size: .28rem;
        padding: .3rem .3rem .6rem .3rem;
        line-height: 1.6;
    }
    .ph-news-detail .ph-news-detail-container .ph-position-bar{
        margin-left: 0;
    }
    .ph-news-detail .ph-news-detail-container .created-time {
        font-size: .26rem;
        color: #6f6f6f;
    }
    .ph-news-detail .ph-news-detail-container .title {
        margin-top: .2rem;
        font-size: .4rem;
        font-weight: 500;
    }
    .ph-news-detail .ph-news-detail-container .pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .ph-news-detail .ph-news-detail-container .html-text-component {

    }
    .ph-news-detail .ph-news-detail-container .html-text-component #news_contain {

    }
    .ph-news-detail .ph-news-detail-container .html-text-component #news_contain img {
        max-width: 100%;
    }
    .line {
        height: 1px;
        background: #6f6f6f;
        margin : .5rem 0;
    }
    .info_con {
        color: #6f6f6f;
    }
</style>
<style scoped>

</style>